import { render, staticRenderFns } from "./rewardGoldenCardTradeEdit.vue?vue&type=template&id=b16148ca&scoped=true&"
import script from "./rewardGoldenCardTradeEdit.vue?vue&type=script&lang=js&"
export * from "./rewardGoldenCardTradeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16148ca",
  null
  
)

export default component.exports